<template>
  <KalaStoreShared :is-accountant="true" />
</template>

<script>
import KalaStoreShared from '@/components/KalaStoreShared.vue'

export default {
  name: 'AccountantKalaStoreView',
  components: { KalaStoreShared },
}
</script>
